import { render, staticRenderFns } from "./BusinessCenter.vue?vue&type=template&id=96c01d9e&"
import script from "./BusinessCenter.vue?vue&type=script&lang=js&"
export * from "./BusinessCenter.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCenter.vue?vue&type=style&index=0&id=96c01d9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports